function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './HobbiesOrInterests.css';
import React, { useEffect, useState } from 'react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import HobbiesAndTravellersTypeCarousel from './components/HobbiesAndTravellersTypeComponents/HobbiesAndTravellersTypeCarousel';
import { get } from '../../utils';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
const HobbiesOrInterests = _ref => {
  let {
    interestingItems,
    buttonLabel,
    getActiveStep,
    getRegisterData,
    params,
    registerData,
    skipButtonLabel,
    handleRegisterUser,
    disableSubmit,
    eventsAnalytics
  } = _ref;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const cardHobbiesInitials = interestingItems;
  const buttonText = get(buttonLabel, 'jss.value');
  const [cardHobbies, setCardHobbies] = useState([]);
  useEffect(() => {
    if (cardHobbiesInitials && cardHobbiesInitials.length) {
      const updatedItems = cardHobbiesInitials.map(item => _objectSpread(_objectSpread({}, item), {}, {
        active: false
      }));
      setCardHobbies(updatedItems);
    }
  }, []);
  const onHobbyCardChoose = key => {
    const cardHobbiessUpdated = [...cardHobbies];
    cardHobbiessUpdated.map(el => {
      const id = get(el, 'key.targetItem.id');
      if (id === key) {
        el.active = !el.active;
      }
    });
    setCardHobbies(cardHobbiessUpdated);
  };
  const registerUser = function () {
    let chosenItems = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    const userData = _objectSpread(_objectSpread({}, registerData), {
      interests: chosenItems
    });
    getRegisterData(userData);
    handleRegisterUser(userData);
  };

  // submit all the information  anyway

  const onSkipButtton = () => {
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['signinCTAsAnalytics'], params), `interests :${skipButtonLabel}`);
    registerUser();
  };
  const onSubmitHobbies = () => {
    const chosenItems = cardHobbies && cardHobbies.filter(el => el.active).map(el => el.key.targetItem.id);
    const chosenItemNames = cardHobbies && cardHobbies.filter(el => el.active).map(el => el.key.targetItem.name);
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['signupCTAsAnalytics'], params), ['interests', `${chosenItemNames}`]);
    registerUser(chosenItems);
  };
  const isSubmitHobbyDisaled = cardHobbies && !cardHobbies.filter(el => el.active).length;
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: `${cardHobbies && cardHobbies.length > 4 ? 'carousel-container' : ''}`
  }, cardHobbies && cardHobbies.length > 0 && /*#__PURE__*/React.createElement(HobbiesAndTravellersTypeCarousel, {
    onItemChoose: onHobbyCardChoose,
    cards: cardHobbies,
    carouselView: cardHobbies.length > 4
  }), /*#__PURE__*/React.createElement("div", {
    className: `carousel-container-navigation ${!cardHobbies || cardHobbies.length === 0 ? 'pt-5' : ''}`
  }, buttonText && /*#__PURE__*/React.createElement("button", {
    onClick: onSubmitHobbies,
    className: "btn btn-primary",
    disabled: isSubmitHobbyDisaled || disableSubmit
  }, buttonText), skipButtonLabel && /*#__PURE__*/React.createElement("button", {
    onClick: onSkipButtton,
    className: "btn btn-tertiary"
  }, skipButtonLabel))));
};
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl
  } = _ref2;
  return /*#__PURE__*/React.createElement("div", {
    className: ` ${rtl ? rtlStyles : ltrStyles} ${commonStyles}`
  }, children);
};
const commonStyles = "cejec1a";
const ltrStyles = "l1vayts7";
const rtlStyles = "r1u3vaw4";
export default HobbiesOrInterests;